<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商品全轨迹查询</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="background: #f3f3f3;height: 30px;line-height:30px;padding: 0 25px;display: flex; align-items: center;"
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto;"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px;">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="打标id">
                  <el-input
                    v-model="form.dbid"
                    placeholder="扫描dbid"
                    @keyup.native.enter="fetchData"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd;">
        <div
          style="background: #f3f3f3;height: 50px;line-height:30px;position: relative"
        >
          打标id:{{ showDbid }}
        </div>
        <div style="margin-bottom: 0;">
          <el-table
            ref="multipleTable"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column label="类型" prop="type"></el-table-column>
            <el-table-column label="环节" prop="operation"></el-table-column>
            <el-table-column label="操作时间" prop="time"></el-table-column>
            <el-table-column label="操作人" prop="admin"></el-table-column>
            <el-table-column label="主要信息" prop="info"></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "DbidTravelLog",
  data() {
    return {
      loading: false,
      filterFold: false,
      form: {
        dbid: null,
      },
      resData: {
        list: [],
      },
      showDbid: "",
    };
  },
  methods: {
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData() {
      this.$http
        .post("/erp/DaBiaoRecord/dbidTravelQuery", {
          dbid: this.form.dbid,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.resData = res.data.data;
            this.showDbid = res.data.data.dbid;
          } else {
            this.$message.e(res.data.msg);
          }
          this.form.dbid = "";
        });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/DbidTravelLog.vue